import { FC,useState, useEffect,  useMemo  } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
//import { Link } from '@react-navigation/native';
//import { Link } from 'react-router-dom';
import {  useLocation, useHistory,Link } from 'react-router-dom';
import moment from "moment";
import $ from 'jquery';


const CompanyJobApplications: FC = () => {
      const intl = useIntl();
      const ITEMS_PER_PAGE = 10; 

     // const companyId='79';
     const location = useLocation();
     const queryParams = new URLSearchParams(location.search);
     const companyId = queryParams.get('companyId');

      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
      const [companyUsers, setCompanyUsers] = useState([]);
      const [jobApplicationsList, setJobApplicationsLIst] = useState<any[]>([]);

      const Pagesize=10;
      const siteId = '2';
      
      function validateCheck() {
        //alert("test");
      } 

      useEffect(() => {
        validateCheck();
        getCompanyJobApplications(ITEMS_PER_PAGE,'1');   
      }, []);

      function getCompanyJobApplications(ITEMS_PER_PAGE:any,pageNumber:any)
      {   
        var searchTxt = $('#search_input').val();
        var statuschk = 'published';
        var sortBy = '';
        var sortDir='';

        const requestObject=
        {         
            "siteId": 2,
            "companyId": companyId,
            "pageSize" : ITEMS_PER_PAGE,
            "pageNumber":pageNumber    
        }

      
        var accessTokenIn=sessionStorage.getItem("adminAccToken");
       const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
                  'Authorization': "Bearer "+accessTokenIn 
                  //'Authorization': accessTokenIn 
                },
        body: JSON.stringify(requestObject)
    };

        
        services.applicationlistbycompany(requestOptions).then((res) => 
        {
           
            console.log(res);
            
            if(res.content){
              setTotalItems(res.totalElements);         
              settotalPages(Math.ceil(res.totalElements / ITEMS_PER_PAGE));            
              setCurrentPage(pageNumber);
              setJobApplicationsLIst(res.content);   
            }
              
        
        });
    }

    const searchList = () => {
        getCompanyJobApplications(ITEMS_PER_PAGE,'1');  
    } 

      const handlePageChange2 = (offset:any,triggerevent:any) => {
        getCompanyJobApplications(ITEMS_PER_PAGE,offset);
      };
      
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Company Job Applications'})}</PageTitle>

          <div className={`card`}>
     
     {/* begin::Body */}
     <div className='card-body py-3'>
       {/* begin::Table container */}
       <div className='table-responsive'>
       {/*<table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>                
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" /> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table> 
            */}
            
         {/* begin::Table */}
         <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
           {/* begin::Table head */}
           <thead>
             <tr className='fw-bolder text-muted'>
             
               <th className='min-w-120px'>Job Title</th>            
               <th className='min-w-120px'>Applicant</th> 
               <th className='min-w-100px text-end'>Actions</th>
             </tr>
           </thead>
           {/* end::Table head */}
           {/* begin::Table body */}
           <tbody>

           {	
	          jobApplicationsList.map((data, index) => (

             <tr>
              
               <td>
                
              <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/viewJobApplication?jobapplicationId='+data.applicationJobId+`&companyIdget=`+companyId+`&tab=4`}><div>{(data.jobTitle=='' || data.jobTitle==null) ? '--' : data.jobTitle}</div>
              <div><strong>Applied on:</strong> <span className="dt-highlt">{(data.createdDate=='' || data.createdDate==null) ? '--' : moment(data.createdDate).utcOffset('-0400').format("MM/DD/YYYY, HH:mm:ss")}</span></div>
              </Link>
                
               </td>
               <td>
<Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={'/viewJobApplication?jobapplicationId='+data.applicationJobId+`&companyIdget=`+companyId+`&tab=4`}> 
<div>{(data.firstName=='' || data.firstName==null) ? '--' : data.firstName+' '+data.lastName} </div>
<div>{(data.phone=='' || data.phone==null) ? '--' : data.phone}</div>
<div>{(data.email=='' || data.email==null) ? '--' : data.email}</div>
</Link>
                
               </td>
             
               <td className='text-end'>

                 <Link className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1' to={'/viewJobApplication?jobapplicationId='+data.applicationJobId+`&companyIdget=`+companyId+`&tab=4`}>
                 <KTSVG path='/media/icons/duotune/art/art012.svg' className='svg-icon-3' />
                 </Link>

               </td>
             </tr>
              ))}
           </tbody>
           {/* end::Table body */}
         </table>

         <Pagination
               
               total={totalItems}
               itemsPerPage={ITEMS_PER_PAGE}
               currentPage={currentPage}
               onPageChange={handlePageChange2}

               /> 
        
         {/* end::Table */}
       </div>
       {/* end::Table container */}
     </div>
     {/* begin::Body */}
   </div>

         
        </>
      )
    }
export {CompanyJobApplications}